/* eslint-disable react/react-in-jsx-scope */
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { addMonths } from "@/libs/utils";
import { ChevronLeft, ChevronRight, TriangleAlert } from "lucide-react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ChartItem from "./ChartItem";

const ReportingDetail = ({ projectData }) => {
  // const data = JSON.parse(localStorage.getItem("project"))

  const [project, setProject] = useState(null);
  const [arrYear, setArrYear] = useState([]);
  const [launchDate, setLaunchDate] = useState(null);
  const [expectedDurationYear, setExpectedDurationYear] = useState(null);
  useEffect(() => {
    if (projectData) {
      setProject(projectData);
    }
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();
  const schParams = searchParams.get("year");
  const yearParam = schParams;
  const [year, setYear] = useState(
    project?.launchDate ? new Date(project?.launchDate).getFullYear() : null
  );
  useEffect(() => {
    setYear(
      project?.launchDate ? new Date(project?.launchDate).getFullYear() : null
    );
    setLaunchDate(
      project?.launchDate ? new Date(project?.launchDate).getFullYear() : null
    );
    const mLaunchDate = project?.launchDate
      ? new Date(project?.launchDate).getFullYear()
      : null;

    const expectedDuration = Number(project?.expectedDuration) || 42;
    const dateWithAddedMonths = addMonths(
      project?.launchDate,
      expectedDuration
    );

    setExpectedDurationYear(
      !dateWithAddedMonths
        ? 0
        : dateWithAddedMonths?.getFullYear() == mLaunchDate
        ? 1
        : dateWithAddedMonths.getFullYear() - mLaunchDate + 1
    );

    setArrYear(
      Array.from(
        {
          length: !dateWithAddedMonths
            ? 0
            : dateWithAddedMonths?.getFullYear() == mLaunchDate
            ? 1
            : dateWithAddedMonths.getFullYear() - mLaunchDate + 1,
        },
        (_, index) => index + 1
      )
    );
  }, [project]);

  const handleSelectYear = (value: string) => {
    const currentYear = Number(value);
    setSearchParams({
      year: currentYear.toString(),
      tab: "reporting",
      id: project?.id,
    });
  };

  const handleYearChange = (action: "prev" | "next") => {
    const currentYear = action === "prev" ? year - 1 : year + 1;
    setYear(currentYear);
    setSearchParams({
      year: currentYear.toString(),
      tab: "reporting",
      id: project.id,
    });
  };

  if (
    project?.launchDate == null ||
    project?.launchDate == undefined ||
    project?.expectedDuration == null ||
    project?.expectedDuration == undefined ||
    project?.expectedDuration == 0
  ) {
    return (
      <p className="mt-4 text-[#878787] flex gap-2">
        <TriangleAlert size={20} /> Veuillez renseigner la date de lancement et
        la durée du projet.
      </p>
    );
  }

  return (
    <div>
      <div className="mb-4 flex justify-end py-3">
        <div className="flex gap-2">
          <div className="flex gap-1">
            <Button
              onClick={() => handleYearChange("prev")}
              className="flex size-8 items-center justify-center rounded-full bg-background p-0 transition-all hover:bg-gray-100"
              disabled={launchDate == (Number(yearParam) || year)}
            >
              <ChevronLeft className="text-foreground" />
            </Button>
            <Button
              onClick={() => handleYearChange("next")}
              className="flex size-8 items-center justify-center rounded-full bg-background p-0 transition-all hover:bg-gray-100"
              disabled={
                launchDate - 1 + expectedDurationYear <=
                (Number(yearParam) || year)
              }
            >
              <ChevronRight className="text-foreground" />
            </Button>
          </div>
          <Select onValueChange={handleSelectYear}>
            <SelectTrigger className="w-16 border-0 px-0 text-lg text-foreground/90 outline-none focus:ring-0 focus:ring-transparent">
              <SelectValue
                placeholder={searchParams.get("year") || launchDate?.toString()}
              />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                {arrYear.map((i, k) => (
                  <SelectItem value={(launchDate + k).toString()} key={k}>
                    {launchDate + k}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="flex flex-wrap -mx-2">
        {project?.indicators
          .filter((indicator) => indicator.graph && indicator.id != 2 && indicator.id != 1)
          .map((indicator, k: number) => (
            <ChartItem
              key={indicator.id}
              project={project}
              indicator={indicator}
              className={`${k % 2 === 0 ? "pr-2" : "pl-2"} w-1/2 mb-4`}
              currentYear={yearParam ? Number(yearParam) : launchDate}
            />
          ))}
      </div>
    </div>
  );
};

export default ReportingDetail;
